import { FeedbackStatus } from 'donor/portal/pages/FeedbackDashboard/api';
import {
  AllVerificationsProgress,
  FeedbackCommentBodyWithIndex,
  VerificationProgress,
} from '../../NPOFeedback/utils';
import {
  isVerificationFeedback,
  ResolvedFeedback,
  VerifyFeedback,
} from '../FeedbackProvider';
import { FeedbackCommentProps } from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';

export const isCommentNewSinceResolved = (
  comment: FeedbackCommentProps | FeedbackCommentBodyWithIndex,
  resolvedAt: string | null | undefined,
): boolean => {
  if (!comment.createdAt || !resolvedAt) return false;
  const created = new Date(comment.createdAt).getTime();
  const resolved = new Date(resolvedAt).getTime();
  if (Number.isNaN(created) || Number.isNaN(resolved)) return false;
  return created > resolved;
};

export const mapFeedbackResolutionProgress = (
  s: FeedbackStatus,
  q: ResolvedFeedback,
  v: VerifyFeedback,
): AllVerificationsProgress => {
  const result: AllVerificationsProgress = {};
  const d = new Date().toDateString();
  const isVerification = isVerificationFeedback(s);
  const ids = isVerification ? v.questionIds : q.questionIds;
  for (const questionId of ids) {
    let r: VerificationProgress;
    if (isVerification) {
      const temp = v.questionsById[questionId];
      r =
        temp === 'rejected'
          ? {
              resolved: undefined,
              tiVerified: undefined,
              donorVerified: undefined,
            }
          : {
              resolved: d,
              tiVerified: d,
              donorVerified: d,
            };
    } else {
      r = {
        resolved: d,
        tiVerified: d,
        donorVerified: d,
      };
    }
    result[questionId] = r;
  }
  return result;
};
